// extracted by mini-css-extract-plugin
module.exports = {"overflow-ellipsis":"badgeDisplayName_overflow-ellipsis__2Sny9","root":"badgeDisplayName_root__1Bjl3","hideOverflow":"badgeDisplayName_hideOverflow__3jKPZ"};